module.exports = __webpack_public_path__ + "res/img/zwhy.ae41f745.png";